<template>
    <form-file :name="name" :accept="accept" :extensions="extensions" no-margin @update:file="onFile">
        <template #default="{ isOverDropZone }">
            <div class="flex justify-center p-4" v-floating-tooltip="`generic.click_to_upload_image`" :class="isOverDropZone ? 'opacity-50' : ''">
                <img :src="previewSrc" :height="height" :width="width" :alt="t('generic.loading')" class="max-h-48 object-contain" />
            </div>
        </template>
    </form-file>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import FormFile from './FormFile.vue';

export default defineComponent({
    name: 'FormImage',

    components: { FormFile },

    props: {
        name: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        extensions: {
            type: String,
        },
        accept: {
            type: String,
        },
        height: {
            type: Number,
        },
        width: {
            type: Number,
        },
    },

    setup(props) {
        const { t } = useI18n();

        const previewSrc = ref(props.image);
        watch(
            () => props.image,
            (image) => (previewSrc.value = image),
        );

        return {
            t,
            previewSrc,

            onFile: (file: File | null) => {
                if (!file) {
                    previewSrc.value = props.image;
                    return;
                }

                const reader = new FileReader();
                reader.onload = (res) => {
                    if (res.target?.result) previewSrc.value = res.target.result.toString();
                };
                reader.readAsDataURL(file);
            },
        };
    },
});
</script>
